import { OauthProvider } from 'src/app/oauth/providers';
import { Injectable } from '@angular/core';
import { IntentCRMExportEnum } from 'src/app/shared/enums/intent-crm-export.enum';
import { ReConnectSettingComponent } from 'src/app/shared/components/re-connect-setting/re-connect-setting.component';
import { LifecycleStageDto } from 'src/app/shared/dto';
import { BehaviorSubject, of, throwError } from 'rxjs';
import { MatDialog,  MatDialogConfig } from '@angular/material/dialog';
import { crmExportValue } from 'src/app/shared/helpers/crm-export-value';
import { SalesforceApiService } from 'src/app/shared/services/api';
import { HubspotApiService } from 'src/app/shared/services/api/hubspot-api.service';
import { ZohoApiService } from 'src/app/shared/services/api/zoho-api.service';
import { DynamicsApiService } from 'src/app/shared/services/api/dynamics-api.service';
import { catchError, tap, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IntentSettingsService {

  leadOwners: {[key in IntentCRMExportEnum]?: any[]} = {};
  hsExportTypes: any[] = [];
  private services: any;
  private reconnectDialogThrottled = false;

  constructor(
    private sfService: SalesforceApiService,
    private hsService: HubspotApiService,
    private zhService: ZohoApiService,
    private dnService: DynamicsApiService,
    private dialog: MatDialog,
  ) {
    this.services = {
        [IntentCRMExportEnum.SALESFORCE]: {
            ownersMethod: sfService.getLeadOwners.bind(sfService),
            refreshTokenMethod: sfService.refreshToken.bind(sfService),
        },
        [IntentCRMExportEnum.HUBSPOT]: {
            ownersMethod: hsService.loadLeadOwner.bind(hsService),
            refreshTokenMethod: hsService.refreshToken.bind(hsService),
        },
        [IntentCRMExportEnum.ZOHO]: {
            ownersMethod: zhService.loadLeadOwners.bind(zhService),
            refreshTokenMethod: zhService.refreshToken.bind(zhService),
        },
        [IntentCRMExportEnum.DYNAMICS]: {
            ownersMethod: dnService.loadLeadOwners.bind(dnService),
            refreshTokenMethod: dnService.refreshToken.bind(dnService),
        }
    }
  }

  public CRMReconnectedSubject:BehaviorSubject<string> = new BehaviorSubject('')
  public readonly CRMReconnected$ = this.CRMReconnectedSubject.asObservable();

    getLeadOwners(crm) {
        const crmName = crmExportValue(crm);
            if (this.leadOwners[crmName]?.length) {
                return of(this.leadOwners[crmName]);
            }
            return this.getList(crmName, this.services[crmName].ownersMethod).pipe(
                tap((data) => this.leadOwners[crmName] = data),
            );
    }

    getHSDefaultTypes() {
        const crmName = IntentCRMExportEnum.HUBSPOT;
        if(this.hsExportTypes?.length) {
            return of(this.hsExportTypes);
        }
        return this.getList(crmName, this.hsService.getLifecycleStages.bind(this.hsService)).pipe(
            tap((data) => this.hsExportTypes = (data as any[]).map((item: LifecycleStageDto) => ({ id: item.value, type: item.label }))),
        );
    }

    getList(crm, method) {
        return method().pipe(
            catchError((err) => this.services[crm].refreshTokenMethod().pipe(
                    switchMap(() => this.getList(crm, method)),
                    catchError((error) => {
                        this.errorRefreshToken(crm.toLowerCase());
                        return throwError(`${crm}: refresh token failed. Reconnection is required.`)
                    })
                )
            )
        )
    }

    errorRefreshToken(provider: OauthProvider) {
        const modalConfig: MatDialogConfig = {
            panelClass: 'modal-lg',
            data: {
                provider: provider,
                match_ids: [],
            }
        };
        if (!this.reconnectDialogThrottled) {
            this.reconnectDialogThrottled = true;
            this.dialog.open(ReConnectSettingComponent, modalConfig).afterClosed().pipe(take(1)).subscribe(() => {
                this.reconnectDialogThrottled = false;
            })
        }
    }

}
